window.lazyLoadInstance = new LazyLoad({
  elements_selector: ".ct-lazy",
  unobserve_completed: true, // set to false if you need tracking if the image leaves the screen
});
